/**
 * @template T
 */
export default class Cycler {
  /**
   * @param {T[]} list The list of items to cycle through
   */
  constructor(list) {
    this.list = list
    this.index = 0
  }

  /**
   * Cycles through the list and returns the next item. When it reaches the end, it cycles back to the beginning.
   * @returns {T} The next item in the list, cycling back to the beginning when it reaches the end
   */
  cycle() {
    const result = this.list[this.index]

    this.index += 1

    if (this.index >= (this.list.length - 1)) {
      this.index = 0
    }

    return result
  }
}

const colors = [
  "#ea31e3",
  "#ea5231",
  "#64bbec",
  "#6a5eec"
]

export {colors}
